import { render } from "./SolicitacoesCrm.vue?vue&type=template&id=35c8576c&scoped=true"
import script from "./SolicitacoesCrm.vue?vue&type=script&lang=js"
export * from "./SolicitacoesCrm.vue?vue&type=script&lang=js"

import "./SolicitacoesCrm.vue?vue&type=style&index=0&id=35c8576c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c8576c"]])

export default __exports__